module.exports = __webpack_public_path__ + "img/agent-puzzle.2ed9108e.svg";